import { addToCart, getCartQty, setCartItem } from '@/store/cart';
import { absoluteImageUrl } from '@/api';
import { formatQuantity, numberFormat } from '@/utils/format';
import { SeasonAll, SeasonSnow, SeasonSun, StudIcon } from '@/ui/Icons.jsx';
import { QtyWidget } from '@/ui/QtyWidget.jsx';
import { notify } from '@/store/ui';
import css from './ProductCard.module.css';

/**
 * Мобильная карточка товара (заменяет строку таблицы на ≤768px).
 * Логика корзины повторяет ProductRow — намеренно, чтобы не связывать
 * десктопный и мобильный рендер общими абстракциями.
 */
export function ProductCard({ product, hideOpt, onImage, onProduct }) {
  const inStockQty = product.in_stock_qty ?? product.total_available ?? 0;
  const inTransitQty = product.in_transit_qty ?? 0;
  const totalAvail = inStockQty + inTransitQty;
  const cartQty = getCartQty(product.id);
  const inCart = cartQty > 0;
  const optPrice = product.opt_price ?? product.price;
  const season = product.specs?.season ?? '';
  const studded = product.specs?.studded ?? false;
  const hasImage = !!product.image_url;

  function changeQty(qty) {
    setCartItem(product, qty);
  }
  function handleAdd() {
    if (inCart) return;
    const qty = Math.max(1, cartQty || 1);
    addToCart(product, qty);
    notify(`${product.name} — ${qty} шт.`);
  }
  function handleRemove() {
    setCartItem(product, 0);
    notify(`${product.name} — убрано из корзины`);
  }

  return (
    <article class={`${css.card} ${inCart ? css.inCart : ''}`}>
      <div class={css.top}>
        <button
          type="button"
          class={`${css.thumb} ${!hasImage ? css.thumbEmpty : ''}`}
          onClick={() => hasImage && onImage(absoluteImageUrl(product.image_url))}
          disabled={!hasImage}
          aria-label={hasImage ? 'Посмотреть фото' : 'Нет фото'}
        >
          {hasImage ? (
            <img src={absoluteImageUrl(product.image_url)} alt="" loading="lazy" />
          ) : (
            <i class="fa-solid fa-image" aria-hidden="true" />
          )}
        </button>

        <div class={css.info}>
          <button type="button" class={css.name} onClick={() => onProduct(product)}>
            {product.name}
          </button>
          <div class={css.meta}>
            <span class={css.season}>
              {season === 'summer' && <SeasonSun />}
              {season === 'winter' && <SeasonSnow />}
              {season === 'all-season' && <SeasonAll />}
              {studded && <StudIcon />}
            </span>
            {product.manufacturer && <span class={css.brand}>{product.manufacturer}</span>}
          </div>
          <div class={css.stocks}>
            <span class={`${css.badge} ${inStockQty > 0 ? css.inStock : css.outOfStock}`}>
              <i class="fa-solid fa-warehouse" aria-hidden="true" /> {formatQuantity(inStockQty)}
            </span>
            {inTransitQty > 0 && (
              <span class={`${css.badge} ${css.transit}`}>
                <i class="fa-solid fa-truck" aria-hidden="true" /> {formatQuantity(inTransitQty)}
              </span>
            )}
          </div>
        </div>
      </div>

      <div class={css.bottom}>
        <div class={css.prices}>
          {!hideOpt && (
            <div class={css.priceOpt}>
              <span class={css.priceLabel}>ОПТ</span>
              <strong>{optPrice > 0 ? `${numberFormat(optPrice)} ₽` : '—'}</strong>
            </div>
          )}
          <div class={css.priceMrc}>
            <span class={css.priceLabel}>МРЦ</span>
            <span>{product.mrc_price ? `${numberFormat(product.mrc_price)} ₽` : '—'}</span>
          </div>
        </div>

        <div class={css.actions}>
          <QtyWidget value={cartQty} max={totalAvail || 999} disabled={totalAvail <= 0} onChange={changeQty} />
          {inCart ? (
            <button class={`btn btn-success btn-sm ${css.cartBtn}`} type="button" onClick={handleRemove}>
              <i class="fa-solid fa-check" /> В корзине
            </button>
          ) : (
            <button
              class={`btn btn-primary btn-sm ${css.cartBtn}`}
              type="button"
              disabled={totalAvail <= 0}
              onClick={handleAdd}
            >
              <i class="fa-solid fa-cart-plus" /> В корзину
            </button>
          )}
        </div>
      </div>
    </article>
  );
}
